// default user data
export function UserModel(data = {}) {
  const defaults = {
    name: "default name",
    // unique uid
    userId: "default-uid",
    // one of 4 numbers corresponding to 1-4? (admin, contributor, aprover?, viewer?)
    // 0 not signed in
    // for now, 1 admin, anything else will be user view
    userTypeId: UserTypeIds.Default,
    description : "",
  };
  return Object.assign({}, defaults, data);
}

// user types
export const UserTypeIds = {
  Default : 0,
  Admin : 1,
  ApproverAVP : 2,
  ApproverDean : 3,
  Contributor : 4,
  Viewer : 5
}